export default __webpack_public_path__ + "static/viinitie-banner-wedding-desktop-extra-wide.9b0fe5d7c1bd8bde0e0d31359daec77e.jpg";